import React, { useMemo } from "react";
import { Button, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { DATE_FORMAT, getFormattedSize, truncateText } from "helpers/common";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import CommonTable from "components/shared/CommonTable";

const DocumentsList = ({ isLoading, data, onClickRemove, handleToggleVisiblity, owner, handleEditNotes }) => {
  // const columnCount = owner === "practitioner" ? 5 : 3;

  const columns = useMemo(() => {
    let cols = [
      {
        key: "document_name",
        component: (item) => (
          <span className="underline">
            <Link
              to={item.document}
              className="text-dark capitalize fw-sbold text-dark py-1 d-block"
              target="_blank"
            >
              {item.document_name}
            </Link>
          </span>
        )
      },
      ...(owner === "practitioner"
        ? [
          {
            key: "notes",
            component: (item) => (
              <div className="d-flex gap-10 align-items-center">
                {item?.notes?.length > 0 && (
                  <p className="m-0 is-multiline" title={item?.notes[0]?.note}>{truncateText(item?.notes[0]?.note, 50)}</p>
                )}
                <div className="d-flex">
                  <Button
                    variant="transparent"
                    className="p-0"
                    onClick={() => {
                      handleEditNotes(item?.id)
                    }}
                  >
                    <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                  </Button>
                </div>
              </div>
            )
          },
          {
            key: "client_visible",
            label: "Visible to Client",
            component: (item) => (
              <div className="cstmSwitch">
                <BootstrapSwitchButton
                  className="rounded-pill"
                  checked={item.client_visible === "yes"}
                  onlabel="Yes"
                  offlabel="No"
                  size="xs"
                  onChange={(isChecked) => {
                    let value = isChecked === true ? "yes" : "no"
                    handleToggleVisiblity(item.id, value)
                  }}
                />
              </div>
            )
          },
          {
            key: "client_viewed_at",
            label: "Client Viewed On",
            component: (item) => item.client_viewed_at ? DATE_FORMAT(item.client_viewed_at) : "--",
          }
        ]
        : []
      ),
      {
        key: "size",
        component: (item) => item.size ? getFormattedSize(item.size) : "0.00 MB",
      },
      {
        key: "created_at",
        label: "Added On",
        component: (item) => DATE_FORMAT(item.created_at),
      },
      {
        key: "Options",
        component: (item) => (
          <Dropdown>
            <Dropdown.Toggle
              className=" bg-white btnSm capitalize text-dark fw-sbold border pe-5 position-relative"
              id="dropdown-basic"
            >
              Options
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                <li>
                  <Link
                    to={item.document}
                    className="text-dark capitalize fw-sbold text-dark px-3 py-1 d-block"
                    target="_blank"
                  >
                    View Document
                  </Link>
                </li>
                {owner === "practitioner" && (
                  <li>
                    <Link
                      to=""
                      onClick={() => {
                        onClickRemove(item.id);
                      }}
                      className="text-dark capitalize fw-sbold text-dark px-3 py-1 d-block"
                    >
                      Remove
                    </Link>
                  </li>
                )}
              </ul>
            </Dropdown.Menu>
          </Dropdown>
        ),
      }
    ]

    return cols;
  }, [owner])

  const columnCount = columns?.length || 0;

  return (
    <>
      <div className="table-responsive client-doc-notes">
        <CommonTable
          isLoading={isLoading}
          data={data}
          columns={columns}
        />
      </div>
    </>
  );
};

export default DocumentsList;
